import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
  Modal,
} from 'react-bootstrap';

import { nodeType } from '../../../../propTypes';
import TicketEntryEnhanced from './TicketEntryEnhanced';


const propTypes = exact({
  // eslint-disable-next-line react/no-unused-prop-types
  ticketId: PropTypes.number.isRequired,
  ticket: nodeType.isRequired,
  showTicketEntryFormModal: PropTypes.bool.isRequired,
  closeTicketEntryForm: PropTypes.func.isRequired,
  canEdit: PropTypes.bool,
  jobId: PropTypes.number.isRequired,
});


const FormWraper = (props) => {
  const { ticket, closeTicketEntryForm, showTicketEntryFormModal, canEdit, jobId } = props;

  return (
    <Modal
      show={showTicketEntryFormModal}
      onHide={closeTicketEntryForm}
    >
      <Modal.Header closeButton>
        <Modal.Title>Ticket</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TicketEntryEnhanced canEdit={canEdit} initialValues={ticket} jobId={jobId} />
      </Modal.Body>
    </Modal>
  );
};


FormWraper.propTypes = propTypes;
FormWraper.defaultProps = {
  canEdit: false,
};


export default FormWraper;
